<template>
    <div
        v-if  = "attachment"
        class="v-flex"
    >
        <c-toolbar-button
            v-if     = "zoomAllowed"
            icon     = "mdi-arrow-expand-all"
            :color   = "color"
            :size    = "iconSize"
            :tooltip = "$t('inb.edit.menu.zoomon')"
            @click   = "onZoom"
        />

        <c-toolbar-button
            v-if     = "saveAllowed && editable && attachment.incidentId === null"
            icon     = "mdi-content-save-outline"
            :color   = "color"
            :size    = "iconSize"
            :tooltip = "$t('inb.edit.menu.save')"
            @click   = "onSave"
        />

        <c-toolbar-button
            v-if     = "saveAllowed && editable && attachment.incidentId === null && attachment.incidentType !== null && attachment.sites && attachment.sites.length > 0"
            icon     = "mdi-plus"
            :color   = "color"
            :size    = "iconSize"
            :tooltip = "$t('inb.edit.menu.create')"
            @click   = "onCreate"
        />

        <c-toolbar-button
            v-if     = "saveAllowed && editable && attachment.incidentId === null && attachment.incidentType !== null && attachment.incidentType !== null && attachment.sites && attachment.sites.length > 0"
            icon     = "mdi-pencil-plus-outline"
            :color   = "color"
            :size    = "iconSize"
            :tooltip = "$t('inb.edit.menu.creategoto')"
            @click   = "onCreateAndGoto"

        />
        <c-toolbar-button
            v-if     = "attachment.incidentId !== null"
            icon     = "mdi-arrow-left"
            :color   = "color"
            :size    = "iconSize"
            :tooltip = "$t('inb.edit.menu.goto')"
            @click   = "onGoto"
        />

        <!--
        <c-toolbar-button
            v-if     = "!this.attachment.ignore && !this.attachment.confirmed"
            icon     = "mdi-check"
            :color   = "color"
            :size    = "iconSize"
            :tooltip = "$t('inb.edit.menu.confirm')"
            @click   = "onConfirm"
        />
        <c-toolbar-button
            v-if     = "!attachment.ignore && attachment.confirmed && attachment.incidentId === null"
            icon     = "mdi-undo-variant"
            :color   = "color"
            :size    = "iconSize"
            :tooltip = "$t('inb.edit.menu.confirmReset')"
            @click   = "onConfirmReset"
        />
        -->
        <c-toolbar-button
            v-if     = "editable"
            icon     = "mdi-delete-outline"
            color   = "error"
            :size    = "iconSize"
            :tooltip = "$t('inb.edit.menu.ignore')"
            @click   = "onIgnore"
        />
        <c-toolbar-button
            v-if     = "attachment.ignore"
            icon     = "mdi-delete-restore"
            color    = "error"
            :size    = "iconSize"
            :tooltip = "$t('inb.edit.menu.ignoreReset')"
            @click   = "onIgnoreReset"
        />
    </div>

</template>

<script>
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton";
import Inb from "@/modules/inb/service/Inb";
import Inc from "@/modules/inc/service/Inc";
import Core from "@/modules/core/service/Core";
export default {
    name: "CInboxAttachmentMenu",
    components: {
        CToolbarButton
    },

    props: {
        attachment: {

        },
        saveAllowed: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },
        zoomAllowed: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        }
    },

    data: () => ({
        iconSize: 20,
        color: "primary",
    }),

    computed: {
        editable () {
            return !this.attachment.ignore && !this.attachment.confirmed && !this.attachment.duplicate;
        }
    },

    methods: {
        onZoom () {
            this.$emit("zoom", !this.zoom);
        },

        onSave () {
            this.$emit("save");
        },

        onCreate() {
            this.$emit("create");
            /*
            Inb.create(this, this.attachment.id, this.$t("inb.loading.create"))
                .then ((data) => {
                    this.attachment.confirmed = true;
                    this.attachment.incidentId = data;
                    this.$emit("refresh", this.attachment.id)
                });

             */
        },

        onCreateAndGoto() {
            this.$emit("creategoto");
            /*
            this.$emit("close");
            Inb.create(this, this.attachment.id, this.$t("inb.loading.create"))
                .then ((data) => {
                    this.attachment.incidentId = data;
                    Inc.goto(this, data);
                });

             */
        },

        onGoto() {
            Core.log("onGoto")
            this.$emit("close");
            Inc.goto(this, this.attachment.incidentId);
        },

        onConfirm() {
            Inb.confirm(this, this.attachment.id, true).then (() => {
                this.attachment.confirmed = true;
                this.$emit("confirmed");
            });
        },

        onConfirmReset() {
            Inb.confirm(this, this.attachment.id, false).then (() => {
                this.attachment.confirmed = false;
                this.$emit("confirmed");
            });
        },

        onIgnore() {
            Inb.ignore(this, this.attachment.id, true).then (() => {
                this.attachment.ignore = true;
                this.attachment.confirmed = true;
                this.$emit("ignore");
            });
        },

        onIgnoreReset() {
            Inb.ignore(this, this.attachment.id, false).then (() => {
                this.attachment.ignore = false;
                this.attachment.confirmed = false;
                this.$emit("ignore");
            });
        },
    }
}
</script>

<style scoped>

</style>